import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';

export const USER_TYPE = {
  system: 1,
  payer: 2,
  provider: 3,
};

export const clientId = 1;

export const USER_ROLE = {
  admin: 1,
};

export const ValidationMsgs = {
  datePattern: 'Date must be in DD/MM/YYYY format',
  EndDateError: 'End Date must be greater than today',
  startDateError: 'Start date must be less than end date',
  requiredMsg: 'This field is required',
  startDateWithCurrentdate: 'Start date must be greater than today',
  saveFaunction : 'Functions Successfully Updated',
  declarationSave : 'Declaration Successfully Updated',
};
export const infoMsg = {
  limit_Dispense: 'The maximum number of days allowed for dispense.',
  refill_Cut_Off: 'The next refill can only be started after these days.',
  max_Refill: 'The maximum number of refill allowed.',
  oneTimeShowFeildInfo: 'This is a one-time setting. It has been left editable for the demo.'
};

export const toasterMsg = {
  forgotPasswordSuccess: 'Email Sent Successfully',
  successReloadDrool: 'Drool Code successfully reloaded',
  successUpadatedDrool: 'Drool Code successfully Updated',
  status401 :'User Token has expired'

};

export const Feild_startDate = {
  type: 'datetimepicker',
  inputClassName: ['form-control date-input'],
  selectedDateClassName: ['selectedDate', 'form-control'],
  arrowClassName: ['arrow'],
  dayClassName: ['dd'],
  todayClassName: ['now'],
  monthClassName: ['mtn'],
  monthListClassName: ['monthlist'],
  yearBtnHeadClassName: ['YY'],
  yearListClassName: ['yList'],
  range: true,
  locale: 'en-IN',
  placeholder: 'DD/MM/YYYY',
  options: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  classname: ['form-control'],
};

export const constantMsg={
  maxFileSize:'xlsx | 3Mb Max. file size'
}

export const constantValues={
  maxFileSize:3,
  dateFormat:'dd/MM/yyyy',
  dateLocale:'en-US'
}

export const validity_date_v2: InputDatepicker = {
  type: 'datepicker_v2',
  name: 'Validity',
  range: true,
  locale: 'en-IN',
  required: true,
  inputClassName: 'form-control date-input',
  selectedDateClassName: 'selectedDate',
  arrowClassName: 'arrow',
  dayClassName: 'dd',
  todayClassName: 'now',
  monthClassName: 'mtn',
  datepickerHeaderClass: '', //classes for the active date div
  headerButtonClass: '', // classes for month-year buttons
  yearClassName: '',
  options: { year: 'numeric', month: '2-digit', day: '2-digit' },
  classname: '',
  timer: false,
  disabled: false, // disables the datepicker
  seperator: ' to ', // seperator b/w dates
  startDatePlaceHolder: 'DD/MM/YYYY',
  dateFormat: 'DD/MM/YYYY', // dd-mm-yyyy | dd/mm/yyyy
  dateSeperator: '/', // seperator b/w dd,mm,yyyy
};

export const datePicker_no_range: InputDatepicker = {
  type: 'datepicker_v2',
  name: 'Validity',
  range: false,
  locale: 'en-IN',
  required: true,
  inputClassName: 'form-control date-input',
  selectedDateClassName: 'selectedDate',
  arrowClassName: 'arrow',
  dayClassName: 'dd',
  todayClassName: 'now',
  monthClassName: 'mtn',
  datepickerHeaderClass: '', //classes for the active date div
  headerButtonClass: '', // classes for month-year buttons
  yearClassName: '',
  options: { year: 'numeric', month: '2-digit', day: '2-digit' },
  classname: '',
  timer: false,
  disabled: false, // disables the datepicker
  seperator: ' to ', // seperator b/w dates
  startDatePlaceHolder: 'DD/MM/YYYY',
  dateFormat: 'DD/MM/YYYY', // dd-mm-yyyy | dd/mm/yyyy
  dateSeperator: '/', // seperator b/w dd,mm,yyyy
};

export const datePicker_disabled: InputDatepicker = {
  type: 'datepicker_v2',
  name: 'Validity',
  range: true,
  locale: 'en-IN',
  required: true,
  inputClassName: 'form-control date-input',
  selectedDateClassName: 'selectedDate',
  arrowClassName: 'arrow',
  dayClassName: 'dd',
  todayClassName: 'now',
  monthClassName: 'mtn',
  datepickerHeaderClass: '', //classes for the active date div
  headerButtonClass: '', // classes for month-year buttons
  yearClassName: '',
  options: { year: 'numeric', month: '2-digit', day: '2-digit' },
  classname: '',
  timer: false,
  disabled: true, // disables the datepicker
  seperator: ' to ', // seperator b/w dates
  startDatePlaceHolder: 'DD/MM/YYYY',
  dateFormat: 'DD/MM/YYYY', // dd-mm-yyyy | dd/mm/yyyy
  dateSeperator: '/', // seperator b/w dd,mm,yyyy
};

export const statusOptions: { label: string; value: number }[] = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 2 },
];

export const validity_date_v2_range_placeholder: InputDatepicker = {
  type: 'datepicker_v2',
  name: 'Validity',
  range: true,
  locale: 'en-IN',
  required: true,
  inputClassName: 'form-control date-input',
  selectedDateClassName: 'selectedDate',
  arrowClassName: 'arrow',
  dayClassName: 'dd',
  todayClassName: 'now',
  monthClassName: 'mtn',
  datepickerHeaderClass: '', //classes for the active date div
  headerButtonClass: '', // classes for month-year buttons
  yearClassName: '',
  options: { year: 'numeric', month: '2-digit', day: '2-digit' },
  classname: '',
  timer: false,
  disabled: false, // disables the datepicker
  seperator: ' to ', // seperator b/w dates
  startDatePlaceHolder: 'DD/MM/YYYY',
  // placeholder:'Validity',
  dateFormat: 'DD/MM/YYYY', // dd-mm-yyyy | dd/mm/yyyy
  dateSeperator: '/', // seperator b/w dd,mm,yyyy
};

export const ruleEngineDefaultFunction = {
  constraints: {
    'Any of the following is true': 'any_of_following_true',
    'All of the following is true': 'all_of_following_true',
    'All of the following is not true': 'all_of_following_not_true',
    // 'Not applicable<only have single item>': 'not_applicable',
  },
  fromConstraints: {
    'From': 'from'
  },
  multipleFieldConstraints: {
    'Any of(OR)': 'anyOfOR',
    'All of (AND)': 'allOfAND',
  },
  constraintOperations: {
    Default: ['equal to', 'not equal to', 'is null', 'is not null'],
    String: [
      'less than',
      'greater than',
      'less than or equal to',
      'greater than or equal to',
      'matches',
      'not matches',
      'sounds like',
      'not soundslike',
      'is contained in the(comma separated) list',
      'is not contained in the(comma separated) list',
    ],
    Integer: [
      'less than',
      'greater than',
      'less than or equal to',
      'greater than or equal to',
      'is contained in the(comma separated) list',
      'is not contained in the(comma separated) list',
    ],

    ArrayList: ['contains', 'excludes', 'has common', 'not has common'],
    Date: [
      'less than',
      'greater than',
      'less than or equal to',
      'greater than or equal to',
      'is contained in the(comma separated) list',
      'is not contained in the(comma separated) list',
      'after',
      'before',
      'coincides',
    ],
  },
  expressionFunctions: {
    String: [
      'charAt(integer)',
      'codePointAt(integer)',
      'codePointBefore(integer)',
      'codePointCount(integer,integer)',
      'compareTo(string)',
      'compareTo(java.lang.Obj)',
      'compareToIgonoreCase(string)',
      'concat(string)',
      'contains(java.lang.CharSequence)',
      'contentsEquals(java.lang.CharSequence)',
      'contentsEquals(java.lang.StringBuffer)',
      'copyValueOf([c)',
      'copyValueOf([c,integer,integer)',
      'empty',
      'endWith(string)',
      'equalsIgnoreCase(string)',
      'format(String.java.lang.Obj)',
      'format(java.util.Locale,String,[Ljava.lang.Obj;)',
      'getBytes(Comparable)',
      'getBytes(String)',
      'indexOf(integer,integer)',
      'indexOf(string)',
      'indexOf(string,integer)',
      'indexOf(integer)',
      'intern()',
      'join(java.lang.CharSequence, [Ljava.lang.CharSequence;)',
      'join(java.lang.CharSequence, java.lang.Iterable) ',
      'lastIndexOf(Integer)',
      'lastIndexOf(Integer, Integer)',
      'lastIndexOf(String)',
      'lastIndexOf(String, Integer)',
      'length()',
      'matches(String)',
      'offsetByCodePoints(Integer, Integer)',
      'regionMatches(Boolean, Integer, String, Integer, Integer)',
      'regionMatches(Integer, String, Integer, Integer) ',
      'replace(String, String)',
      'replace(java.lang.CharSequence, java.lang.CharSequence)',
      'replaceAll(String, String)',
      'replaceFirst(String, String)',
      'split(String)',
      'split(String, Integer)',
      'startsWith(String)',
      'startsWith(String, Integer)',
      'subSequence(Integer, Integer)',
      'substring(Integer)',
      'substring(Integer, Integer)',
      'toCharArray()',
      'toLowerCase()',
      'toLowerCase(java.util.Locale)',
      'toUpperCase()',
      'toUpperCase(java.util.Locale)',
      'trim()',
      'valueOf(Boolean)',
      'valueOf(Double)',
      'valueOf(Float)',
      'valueOf(Integer)',
      'valueOf(Long)',
      'valueOf(String)',
      'valueOf([C)',
      'valueOf([C, Integer, Integer)',
      'valueOf(java.lang.Object)',
    ],
    Integer: [
      'bitCount(Integer)',
      'byteValue()',
      'compare(Integer, Integer)',
      'compareTo(Integer)',
      'compareTo(java.lang.Object)',
      'compareUnsigned(Integer, Integer)',
      'decode(String)',
      'divideUnsigned(Integer, Integer)',
      'doubleValue()',
      'floatValue()',
      'getInteger(String)',
      'getInteger(String, Integer)',
      'highestOneBit(Integer)',
      'intValue()',
      'longValue()',
      'lowestOneBit(Integer)',
      'max(Integer, Integer)',
      'min(Integer, Integer)',
      'numberOfLeadingZeros(Integer)',
      'numberOfTrailingZeros(Integer)',
      'parseInt(String)',
      'parseInt(String, Integer)',
      'parseUnsignedInt(String)',
      'parseUnsignedInt(String, Integer)',
      'remainderUnsigned(Integer, Integer)',
      'reverse(Integer)',
      'reverseBytes(Integer)',
      'rotateLeft(Integer, Integer)',
      'rotateRight(Integer, Integer)',
      'shortValue()',
      'signum(Integer)',
      'sum(Integer, Integer)',
      'toBinaryString(Integer)',
      'toHexString(Integer)',
      'toOctalString(Integer)',
      'toUnsignedLong(Integer)',
      'toUnsignedString(Integer)',
      'toUnsignedString(Integer, Integer)',
      'valueOf(Integer)',
      'valueOf(String)',
      'valueOf(String, Integer)',
    ],
    Date: [
      'UTC(Integer, Integer, Integer, Integer, Integer, Integer)',
      'after(Date)',
      'before(Date)',
      'clone()',
      'compareTo(Date)',
      'compareTo(java.lang.Object)',
      'date',
      'day',
      'from(Comparable)',
      'hours',
      'minutes',
      'month',
      'parse(String)',
      'seconds',
      'time',
      'timezoneOffset',
      'toGMTString()',
      'toInstant()',
      'toLocaleString()',
      'year',
    ],
    ArrayList: [
      'add(java.lang.Object)',
      'contains(java.lang.Object)',
      'empty',
      'get(Integer)',
      'indexOf(java.lang.Object)',
      'lastIndexOf(java.lang.Object)',
      'remove(Integer)',
      'remove(java.lang.Object)',
      'set(Integer, java.lang.Object)',
      'size()',
      'spliterator()',
    ],
  },
}

export enum SUB_TYPE {
  payer ='PAYER',
  provider = 'PROVIDER',
  both = 'BOTH'
}
